// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"61777a34","453":"5ee72f94","793":"b4919485"}[chunkId] + ".chunk.js";
};